<template>
  <!-- 会员中心-互助会员 -->
  <div>
    <div class="mutualMember">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <div class="head">互动会员</div>
        <div class="input-form-box" style="margin-top: 20px">
          <formOne :pageName="pageName" @onSerach="searchFormOne"></formOne>
        </div>
      </div>
      <div class="content">
        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="talbeLoading"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            prop="memberNick"
            label="会员昵称"
            width="200"
          ></el-table-column>
          <el-table-column prop="levelName" label="会员等级"></el-table-column>
          <el-table-column
            prop="point"
            label="当前积分"
            width="200"
          ></el-table-column>
          <el-table-column prop="activationStatus" label="是否开卡" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.activationStatus | statusStr }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="activationTime"
            label="开卡时间"
          ></el-table-column>
          <el-table-column
            prop="lastActivityTime"
            label="最后参与店铺活动时间"
          ></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <div class="btns">
                <!-- 会员信息弹框 -->
                <span
                  class="b1"
                  @click="leverInfo(scope.row.id)"
                  v-zoom="{ from: pageName, name: '会员信息' }"
                  >会员信息</span
                >
                <el-dialog
                  title="会员信息"
                  :visible.sync="levelInfo"
                  width="550px"
                >
                  <el-form :model="formData">
                    <el-form-item
                      label="会员昵称:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.memberNick"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="手机号码:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.mobile"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="会员等级:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.levelName"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="当前积分:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.point"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="是否开卡:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.activationStatus"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="入会店铺:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.shopTitle"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="开卡时间:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.activationTime"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="最后参与活动时间:"
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formData.lastActivityTime"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="会员生日:"
                      :label-width="formLabelWidth"
                    >
                      <el-date-picker
                        v-model="formData.birthDay"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                        style="width: 250px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="levelInfo = false">取 消</el-button>
                    <el-button type="primary" @click="levelSure()"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>

                <!-- 积分日志弹框 -->
                <span
                  class="b2"
                  v-zoom="{ from: pageName, name: '积分日志' }"
                  @click="pointsLog(scope.row.id)"
                  >积分日志</span
                >
                <el-dialog :visible.sync="pointLog" width="980px">
                  <div slot="title" class="dialog-title">
                    <span>积分日志</span>
                    <el-popover
                      placement="right-start"
                      width="200"
                      trigger="hover"
                      content="当前积分变更日志仅记录本积分系统所涉及的变更明细"
                    >
                      <img
                        class="img3"
                        src="@/assets/images/u103.png"
                        alt=""
                        slot="reference"
                      />
                    </el-popover>
                  </div>
                  <el-table :data="gridData">
                    <el-table-column
                      property="changeTime"
                      label="变更时间"
                    ></el-table-column>
                    <el-table-column label="发放/扣除">
                      <template slot-scope="scope">
                        <span>{{
                          scope.row.changeScores > 0 ? "发放" : "扣除"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="变更积分值"
                      property="changeScores"
                    ></el-table-column>
                    <el-table-column property="currentScores">
                      <template slot="header" slot-scope="scope">
                        <span>当前积分值</span>
                        <el-popover
                          placement="right-start"
                          width="200"
                          trigger="hover"
                          content="京东接口返回当前用户的积分值"
                        >
                          <img
                            class="img3"
                            src="@/assets/images/u103.png"
                            alt=""
                            slot="reference"
                          />
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column
                      property="reason"
                      label="变更原因"
                    ></el-table-column>
                    <el-table-column
                      property="remark"
                      label="变更备注"
                    ></el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @size-change="logHandleSizeChange"
                    @current-change="logHandleCurrentChange"
                    :current-page="logCurrentPage"
                    :page-sizes="[10, 30, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    class="pagination"
                    :total="totalNum"
                  ></el-pagination>
                </el-dialog>

                <!-- 积分变更弹框 -->
                <span
                  class="b3"
                  v-zoom="{ from: pageName, name: '积分变更' }"
                  @click="changePonitCahnge(scope.row.id)"
                  >积分变更</span
                >
                <el-dialog
                  title="积分变更"
                  :visible.sync="changePonit"
                  width="500px"
                >
                  <el-form :model="formDataOne">
                    <el-form-item
                      label="会员昵称："
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formDataOne.memberNick"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="当前积分："
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formDataOne.currentPoint"
                        style="width: 250px"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="变更操作："
                      :label-width="formLabelWidth"
                    >
                      <el-radio-group v-model="formDataOne.sourceType">
                        <el-radio label="27">发放</el-radio>
                        <el-radio label="26">扣除</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      label="变更积分值："
                      :label-width="formLabelWidth"
                    >
                      <el-input
                        v-model="formDataOne.points"
                        style="width: 250px"
                        type="number"
                        @change="linePan"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" :label-width="formLabelWidth">
                      <el-input
                        v-model="formDataOne.sourceComment"
                        style="width: 250px"
                        :maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="changePonit = false">取 消</el-button>
                    <el-button type="primary" @click="changePonitSure"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
// import inputForm from "../../../components/inputForm";
import {
  memberList,
  member,
  detail,
  point,
  details,
} from "@/api/integralCenter/memberController";
import formOne from "../inputFrom/input_form";
export default {
  name: "mutualMember",
  filters: {
    statusStr(status) {
      return { 0: "未开卡", 1: "已开卡", null: "null" }[status];
    },
  },
  components: {
    topTitle,
    // inputForm,
    formOne,
  },
  data() {
    return {
      pageName: "忠诚度管理-互动会员",
      numTotal: 0,
      totalNum: 0,
      //会员信息弹框
      levelInfo: false,
      form: {
        resource: "1",
      },
      formLabelWidth: "150px",
      value1: "",
      //积分日志弹框
      pointLog: false,
      logCurrentPage: 1,
      gridData: [],
      //积分变更弹框
      changePonit: false,
      // 头部表单配置项
      inputData: [
        {
          name: "会员昵称:",
          val: "nick",
          placeholder: "请输入会员昵称",
        },
        {
          name: "客户pin:",
          val: "pin",
          placeholder: "请输入客户pin",
        },
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入手机号码",
        },
        {
          name: "会员等级:",
          val: "memberLevel",
          selectArr: [
            { label: "一星会员", id: 1 },
            { label: "二星会员", id: 2 },
            { label: "三星会员", id: 3 },
            { label: "四星会员", id: 4 },
            { label: "五星会员", id: 5 },
          ],
        },
        {
          name: "是否开卡:",
          val: "memberLevel",
          selectArr: [
            { label: "已开卡", id: 1 },
            { label: "未开卡", id: 0 },
          ],
        },
        {
          name: "开卡时间:",
          myDate: true,
          val: ["cardStartTime", "cardEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "最后参与活动时间:",
          myDate: true,
          val: ["lastStartTime", "lastEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      currentPage: 1, // 表格当前页
      levelData: {
        // activationEndTime: "", //开卡时间-结束
        // activationStartTime: "", //开卡时间-开始
        // activationStatus: 0, //开卡状态：0未开卡，1已开卡
        current: 1,
        // lastActivityEndTime: "", //最后参与活动时间-结束
        // lastActivityStartTime: "", //最后参与活动时间-开始
        // level: 0, //会员等级
        // memberNick: "", //会员昵称
        // mobile: "", //手机号码
        // pin: "", //会员pin
        size: 10,
      },
      formData: {}, //积分日志
      formDataOne: {
        memberNick: "", //名称
        score: "", //当前积分
        sourceType: "27", //发放/扣除
        points: "", //变更积分值
        sourceComment: "", //备注
        memberId: "",
      }, //积分变更
      activationStatus: "",
      log: {
        size: 10,
        current: 1,
      },
      ids: "",
      mytimestart: "",
      mytimeend: "",
      opentime:true,
    };
  },
  created() {
    // for (let i = 0; i < 10; i++) {
    //   this.tableData.push({
    //     nick: "阿狸",
    //     memberLevel: "一星会员",
    //     currentInt: 27,
    //     isOpenCard: i & 1 ? "是" : "否",
    //     openCardTime: i & 1 ? "2019-07-02 00:00:00" : "-",
    //     lastTime: "2019-07-30 00:00:00",
    //   });
    // }
  },
  mounted() {
    this.time();
    // this.memberList();
    var loginValue = sessionStorage.getItem("loginValue");
    if (loginValue == 1) {
      this.memberList();
    }
  },
  methods: {
      time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    linePan(val) {
      let test = /^[0-9]*[1-9][0-9]*$/;
      if (this.formDataOne.sourceType == "27") {
        if (!test.exec(val)) {
          this.$message.error("请输入正确数字！");
          return;
        }
      }
    },
    //会员信息确认
    levelSure() {
      let birthdayInfo = {
        birthDay: this.formData.birthDay,
        id: this.ids,
      };
      member(birthdayInfo)
        .then((res) => {
          if (res.code == 1) {
            this.memberList();
            this.$message.success("修改成功");
          }
        })
        .catch(() => {});
      this.levelInfo = false;
    },
    //会员信息
    leverInfo(id) {
      this.ids = id;
      this.levelInfo = true;
      detail(id)
        .then((res) => {
          if (res.code == 1) {
            this.formData = res.data;
            if (this.formData.activationStatus == 0) {
              this.formData.activationStatus = "未开卡";
            } else {
              this.formData.activationStatus = "已开卡";
            }
          }
        })
        .catch(() => {});
    },
    //获取列表数据
    memberList() {
      this.talbeLoading = true;
             if (this.opentime==true) {
        this.levelData.activationStartTime = this.mytimestart;
      this.levelData.activationEndTime = this.mytimeend;
      // this.levelData.lastActivityStartTime = this.mytimestart;
      //  this.levelData.lastActivityEndTime = this.mytimeend;
        this.opentime=false;
      }
      console.log(this.levelData);
      memberList(this.levelData).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.talbeLoading = false;
          this.tableData = res.data.records;
          this.numTotal = Number(res.data.total);
        }
      });
    },
    //积分日志
    pointsLog(value) {
      this.pointLog = true;
      this.log.memberId = value;
      // this.log.memberId="1304063433587437569"
      details(this.log).then((res) => {
        this.gridData = res.data.records;
        this.totalNum = Number(res.data.total);
      });
    },
    // 积分日志分页
    logHandleSizeChange(val) {
      this.log.size = Number(val);
      this.pointsLog(this.log.memberId);
    },
    logHandleCurrentChange(val) {
      this.log.current = Number(val);
      this.pointsLog(this.log.memberId);
    },
    //积分变更
    changePonitCahnge(id) {
      this.changePonit = true;
      this.formDataOne.memberId = id;
      this.formDataOne.points = null;
      this.formDataOne.sourceComment = "";
      detail(id)
        .then((res) => {
          if (res.code == 1) {
            this.formDataOne.memberNick = res.data.memberNick;
            this.formDataOne.currentPoint = res.data.point;
          }
        })
        .catch(() => {});
    },
    //积分变更确定
    changePonitSure() {
      if (this.formDataOne.sourceType == 26) {
        this.formDataOne.points = "-" + this.formDataOne.points;
      }
      point(this.formDataOne).then((res) => {
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.memberList();
        } else {
          this.$message.error(res.message);
        }
      });
      this.changePonit = false;
    },
    //查询
    searchFormOne(val) {
      this.logCurrentPage = 1;
      this.levelData.memberNick = val.theme;
      this.levelData.mobile = val.monile;
      this.levelData.pin = val.fullName;
      this.levelData.level = val.orderRemark;
      this.levelData.activationStatus = val.orderstatus;
      this.levelData.activationStartTime = val.orderStartTimeStart;
      this.levelData.activationEndTime = val.orderStartTimeEnd;
      this.levelData.lastActivityStartTime = val.sendStartTimeStart;
      this.levelData.lastActivityEndTime = val.sendStartTimeEnd;
      this.levelData.current = 1;
      this.levelData.size = 10;
      this.memberList();
    },
    /**
     * 分页变化事件
     */
    handleSizeChange(val) {
      this.levelData.size = val;
      this.memberList();
    },
    handleCurrentChange(val) {
      this.levelData.current = val;
      this.memberList();
    },
  },
};
</script>

<style scoped lang="scss">
.mutualMember {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .headForm {
    box-sizing: border-box;
    margin-top: 20px;
    padding: 24px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      border-bottom: 1px solid #f0f0f0;
      padding: 0 0 20px 50px;
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin: 20px 0 50px 0;
    .btns {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      span {
        padding: 10px 2px;
      }
      .b1 {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .b2 {
        margin: 0 30px;
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .img3 {
        height: 18px;
        // position: flex;
        margin: 0 0 -4px 0;
      }
      .b3 {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
